import PropTypes from 'prop-types';
import User from '../singletons/User';
import {Observer} from 'mobx-react-lite';
import {Redirect, Route} from 'react-router-dom';
import {LOGIN} from '../constants/routing';

const AuthRoute = ({render, component, children, ...props}) => (
  <Route
    {...props}
    render={() => (
      <Observer>
        {() => (User.needsLogin ? <Redirect to={LOGIN} /> : children)}
      </Observer>
    )}
  />
);

AuthRoute.propTypes = {
  render: PropTypes.any,
  component: PropTypes.any,
  path: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default AuthRoute;
